import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

function ThemeScope ({ variables, children, style, ...divProps }) {
  const _style = useMemo(() => {
    return {
      ...(style || {}),
      ...(variables.reduce((p, c) => {
        p[c.key] = c.value
        return p
      }, {}))
    }
  }, [variables, style])

  return (
    <div {...divProps} style={_style}>
      {children}
    </div>
  )
}

ThemeScope.propTypes = {
  variables: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.any
  })),
  style: PropTypes.object,
  children: PropTypes.node
}

export default ThemeScope
